(() => {
  const container = document.getElementById('ProductGridContainer');
  const collectionComponent = container?.closest('collection-component');
  if (!container || !collectionComponent) return;

  const desktop = window.matchMedia('(min-width: 750px)');
  const listReturn = window.BSListReturn;
  let observer;
  let controller;
  let generation = 0;
  let restoreStarted = false;

  function stop() {
    generation += 1;
    observer?.disconnect();
    controller?.abort();
    observer = undefined;
    controller = undefined;
    collectionComponent.classList.remove('bs-infinite-scroll-active');
    container.querySelector('.bs-infinite-scroll-sentinel')?.remove();
    container.querySelector('.bs-infinite-scroll-status')?.remove();
    container.querySelector('.bs-collection-load-actions')?.remove();
  }

  function setup() {
    stop();
    if (!desktop.matches) return;

    const collection = container.querySelector('.collection');
    const grid = collection?.querySelector('#product-grid');
    const pagination = collection?.querySelector('.pagination-wrapper');
    if (!grid || !pagination) return;

    let nextPageUrl = collection.dataset.nextPageUrl;
    if (!nextPageUrl) return;
    let loadedPages = 1;
    listReturn?.setLoadedPages(loadedPages);
    const buttonMode = collectionComponent.dataset.bsLoadMode === 'button';
    if (!buttonMode && !('IntersectionObserver' in window)) return;

    let sentinel;
    let actions;
    let button;
    const status = document.createElement('div');
    status.className = 'bs-infinite-scroll-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.textContent = '次の商品を読み込み中…';

    const currentGeneration = generation;
    async function loadNext(restoring = false) {
      if (controller || !nextPageUrl) return false;
      if (collection.classList.contains('loading')) return false;

      if (sentinel) observer?.unobserve(sentinel);
      controller = new AbortController();
      if (buttonMode) {
        button.disabled = true;
        button.textContent = '読み込み中…';
      } else {
        status.classList.add('is-loading');
      }

      try {
        const url = new URL(nextPageUrl, window.location.origin);
        url.searchParams.set('section_id', grid.dataset.id);
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextCollection = page.querySelector('#ProductGridContainer .collection');
        const nextItems = page.querySelectorAll('#ProductGridContainer #product-grid > li.grid__item');
        if (!nextCollection || nextItems.length === 0) throw new Error('商品を取得できませんでした');
        if (currentGeneration !== generation || !desktop.matches) return false;

        nextItems.forEach((item) => {
          item.querySelectorAll('.scroll-trigger').forEach((element) => {
            element.classList.remove('scroll-trigger', 'animate--slide-in');
          });
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          item.style.removeProperty('--animation-order');
          grid.append(item);
        });
        nextPageUrl = nextCollection.dataset.nextPageUrl;
        loadedPages += 1;
        listReturn?.setLoadedPages(loadedPages);
        return true;
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Collection infinite scroll:', error);
          stop(); // Restore the normal pagination links if loading fails.
        }
        return false;
      } finally {
        if (currentGeneration === generation) {
          controller = undefined;
          status.classList.remove('is-loading');
          if (buttonMode) {
            button.disabled = false;
            button.textContent = 'もっと見る';
            if (!nextPageUrl) actions.remove();
          } else if (nextPageUrl) {
            if (!restoring) observer.observe(sentinel);
          } else {
            sentinel.remove();
          }
        }
      }
    }

    if (buttonMode) {
      actions = document.createElement('div');
      actions.className = 'bs-collection-load-actions';
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary bs-collection-more-button';
      button.textContent = 'もっと見る';
      button.addEventListener('click', () => loadNext());
      actions.append(button);
      collection.append(actions, status);
    } else {
      sentinel = document.createElement('div');
      sentinel.className = 'bs-infinite-scroll-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      // Dawn hides empty divs globally, so keep the observer target non-empty.
      sentinel.textContent = '\u00a0';
      sentinel.style.height = '1px';
      sentinel.style.overflow = 'hidden';
      collection.append(sentinel, status);
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      }, { rootMargin: '500px 0px' });
      if (!listReturn?.pending) observer.observe(sentinel);
    }
    collectionComponent.classList.add('bs-infinite-scroll-active');

    if (listReturn?.pending && !restoreStarted) {
      listReturn.registerCollectionRestore(async (saved) => {
        restoreStarted = true;
        if (!desktop.matches) {
          await listReturn.finishRestore(saved);
          return;
        }
        const targetPages = Math.max(1, Number(saved.loadedPages) || 1);
        while (loadedPages < targetPages && nextPageUrl && currentGeneration === generation) {
          if (!(await loadNext(true))) break;
        }
        if (currentGeneration !== generation) return;
        await listReturn.finishRestore(saved);
        if (!buttonMode && nextPageUrl) observer.observe(sentinel);
      });
    }
  }

  new MutationObserver(setup).observe(container, { childList: true });
  desktop.addEventListener('change', setup);
  setup();
})();
